import React from 'react'
import {
PageTitleText 
} from '../../../../widget/styledComponents/headings.style';
import Analytics from './widgets/analytics'
import PropertyMetricWidget from './widgets/property'
import Cookies from 'js-cookie';
import ComplaintsWidget from './widgets/complaints';
import HomeCalendar from './widgets/calendar';
// import AddAssetsPrompt from '../../../../widget/add_assets_prompt';


  
function DashboardHome() {
const userName = Cookies.get('userName');

  return (
    <div className=''>
      {/* <AddAssetsPrompt/> */}
      <br/><br/>
      <div className='row'>
          <div className='col s12' style={{
            display:"flex"
          }}>
              <PageTitleText>
                Hi {userName} 
              </PageTitleText>
          </div>
      </div>
      <div >
        <Analytics/>
        <div className='row'>
          <div className='col s12 l9'>
            <ComplaintsWidget/>
          </div>
          <div className='col s12 l3'>
            <HomeCalendar/>
          </div>
        </div>
        <div className='row'>
          <div className='col s12 '>
            <PropertyMetricWidget/>
          </div>
        </div>
      </div>
      
    </div>
  )
}

export default DashboardHome